import Vue from "vue";
import Router from "vue-router";
// Error HTTP  views
import Error401 from "@/views/error/401";
import Error404 from "@/views/error/404";
import Error503 from "@/views/error/503";
// Talentos
import Talento from "@/views/talento/Talento";

Vue.use(Router);

export default new Router({
  mode: "history"
  , routes: [
    /* RECRUITMENT */
    {
      path: ""
      , redirect: "/talento"
    }
    /* ERRORS */
    , {
      path: "/404NotFound"
      , name: "PageNotFound"
      , component: Error404
    }
    , {
      path: "/401Unauthorized"
      , name: "401Unauthorized"
      , component: Error401
    }
    , {
      path: "/503Error"
      , name: "serviceUnavailable"
      , component: Error503
    }
    /* VIEWS */
    , {
      path: "/talento"
      , name: "Talento"
      , component: Talento
    }
    , {
      path: "/*"
      , redirect: "/talento"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js